const getSafe = (fn, fallback = null) => {
  try {
    return fn()
  } catch (e) {
    return fallback
  }
}

export default getSafe
